import { render, staticRenderFns } from "./ProviderSummaryPanel.vue?vue&type=template&id=f96acb12&"
import script from "./ProviderSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./ProviderSummaryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports